module.exports = __webpack_public_path__ + "static/media/Pyjama Girl.3077d7c0.jpg";